import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import VideoPreview from '../VideoPreview/VideoPreview';
import { useMostPopularCard } from '../../hooks/useMostPopularCard';
import styles from './MostPopularCard.module.css';

const MostPopularCard = ({
    size = "Desktop 1440",
    onViewMoreClick
}) => {
    const navigate = useNavigate();
    const { cardData, isLoading, error } = useMostPopularCard();
    const [displayedDescription, setDisplayedDescription] = useState("");
    const [isDescriptionTruncated, setIsDescriptionTruncated] = useState(false);

    useEffect(() => {
        if (cardData?.company_overview?.description) {
            const maxLength = size === "Tablet" ? 80 : 120;
            const description = cardData.company_overview.description;
            
            if (description.length > maxLength) {
                setDisplayedDescription(description.slice(0, maxLength));
                setIsDescriptionTruncated(true);
            } else {
                setDisplayedDescription(description);
                setIsDescriptionTruncated(false);
            }
        }
    }, [cardData?.company_overview?.description, size]);

    const handleViewMoreClick = (e) => {
        e.preventDefault();
        if (onViewMoreClick) {
            onViewMoreClick();
        } else if (cardData?.companyname) {
            navigate(`/company/${cardData.companyname.toLowerCase().replace(/\s+/g, '_')}`);
        }
    };

    if (isLoading) {
        return <div className={styles.loading}>Loading most popular card...</div>;
    }

    if (error) {
        console.error('MostPopularCard error:', error);
        return <div className={styles.error}>Error loading most popular card: {error.message}</div>;
    }

    if (!cardData) {
        return null;
    }

    const sizeClass = size.toLowerCase().replace(" ", "");

    return (
        <div 
            className={`${styles.card} ${styles[sizeClass]}`}
            style={{ backgroundColor: cardData.card_color }}
        >
            <div className={`${styles.contentContainer} ${styles[sizeClass]}`}>
                <div className={`${styles.textContainer} ${styles[sizeClass]}`}>
                    <div className={styles.categoryDateContainer}>
                        <span className={`${styles.category} ${styles[sizeClass]}`}>
                            {cardData.categories?.name || 'Uncategorized'}
                        </span>
                        <span className={`${styles.date} ${styles[sizeClass]}`}>
                            {cardData.formattedAddedTime}
                        </span>
                    </div>
                    <span className={`${styles.summary} ${styles[sizeClass]}`}>
                        {cardData.summary}
                    </span>
                    <p className={`${styles.description} ${styles[sizeClass]}`}>
                        {displayedDescription}
                        {isDescriptionTruncated && (
                            <>
                                ...
                                <span
                                    className={`${styles.viewMore} ${styles[sizeClass]}`}
                                    onClick={handleViewMoreClick}
                                >
                                    View more
                                </span>
                            </>
                        )}
                    </p>
                </div>
                <div className={`${styles.videoContainer} ${styles[sizeClass]}`}>
                    <VideoPreview
                        companyId={cardData.companyoverviewid}
                        size="Phone"
                        autoPlay={true}
                        controls={false}
                        loop={true}
                    />
                </div>
            </div>
        </div>
    );
};

export default MostPopularCard;